module.exports = __webpack_public_path__ + "img/img_shuiyin_h5.088ac57a.png";